import { SearchField } from 'modules/domains';
import { SetConditionFn, useSetCondition } from './useSetCondition';
import { useCondition } from './useCondition';

export const useConditionState = (): [condition: SearchField, setCondition: SetConditionFn] => {
  const condition = useCondition();
  const setCondition = useSetCondition();
  return [condition, setCondition];
};
